import { assocPath, path } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatFieldValues, useFieldsForBulkForm } from '../../../utils/helpers/fields'
import { useSaveUsers } from './_requests/saveUsers'
import { useUsers } from './_load/UsersLoader'
import BulkForm from '../../../packages/kiti/components/form/form/BulkForm'
import Form from '../../../packages/kiti/components/form/form/Form'
import GroupSelect from '../../../containers/groups/select/GroupSelect'
import Line from '../../../packages/kiti/components/helpers/Line'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import ProfileSelect from '../../../containers/profiles/select/ProfileSelect'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import TimeSelect from '../../../components/form/TimeSelect'

const EditUsersForm = () => {
  const { t } = useTranslation('editUser')
  const fieldValuesPath = ['contract', 'fieldValues']
  const [fields, { loading: loadingFields }] = useFieldsForBulkForm('contracts', fieldValuesPath)
  const [onSubmit, { loading, error }] = useSaveUsers()
  const users = useUsers()

  if (loadingFields) return <Loading />

  const isEditing = !!users?.length
  const initialItemValue = assocPath(fieldValuesPath, formatFieldValues([], 'contracts'), {})
  const initialState = isEditing
    ? users.map(item => assocPath(fieldValuesPath, formatFieldValues(path(fieldValuesPath, item), 'contracts'), item))
    : [initialItemValue, initialItemValue]

  if (loadingFields) return <Loading />

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <Scroll height="69vh" scroll scrollX direction="row">
        <Separator weight={8} flex={1}>
          <BulkForm
            isEditing={isEditing}
            initialItemState={initialItemValue}
            fields={[
              { label: t('name') + '*', name: 'name', width: 15 },
              { label: t('email') + '*', name: 'email' },
              { label: t('profile') + '*', path: ['contract'], name: 'profile', Input: ProfileSelect },
              { label: t('groups'), path: ['contract'], name: 'groups', Input: GroupSelect, multiple: true },
              {
                label: t('productiveCapacity'),
                path: ['contract'],
                name: 'workShifts',
                Input: TimeSelect
              },
              ...fields
            ]}
          />
        </Separator>
      </Scroll>
      <Line />
      <Separator paddingH={2}>
        <SubmitBar loading={loading} error={error} />
      </Separator>
    </Form>
  )
}

export default EditUsersForm
